import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative mt-32 on-dark" style={{ background: "var(--ss-bg-2)", borderTop: "1px solid var(--ss-border)" }}>
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <Logo size="lg" tagline={true} />
          <p className="mt-8 font-body text-base md:text-lg max-w-md" style={{ color: "var(--ss-cream-dim)" }}>
            One brand, four experiences. Bartending, DJ, nightclub rentals, and custom event details — built to make your event unforgettable.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/book" data-testid="footer-book-btn" className="btn-primary">Book Your Event</Link>
            <a href="https://instagram.com/simplysocialchicago" target="_blank" rel="noreferrer"
               data-testid="footer-ig-btn" className="btn-outline">
              <Instagram size={14} /> @simplysocialchicago
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-label text-xs mb-5" style={{ color: "var(--ss-cream-dim)" }}>Experiences</div>
          <ul className="space-y-3 font-body">
            <li><Link to="/the-social-bar" className="hover:text-[color:var(--ss-rust)] transition-colors">The Social Bar</Link></li>
            <li><Link to="/the-social-set" className="hover:text-[color:var(--ss-rust)] transition-colors">The Social Set</Link></li>
            <li><Link to="/nightclub-rentals" className="hover:text-[color:var(--ss-rust)] transition-colors">Nightclub Rentals</Link></li>
            <li><Link to="/the-social-supply" className="hover:text-[color:var(--ss-rust)] transition-colors">The Social Supply</Link></li>
            <li><Link to="/build" className="hover:text-[color:var(--ss-rust)] transition-colors">Build Your Experience</Link></li>
            <li><Link to="/gift-cards" className="hover:text-[color:var(--ss-rust)] transition-colors">Gift Cards</Link></li>
            <li><Link to="/my-booking" data-testid="footer-my-booking" className="hover:text-[color:var(--ss-rust)] transition-colors">My Booking</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-label text-xs mb-5" style={{ color: "var(--ss-cream-dim)" }}>Contact</div>
          <ul className="space-y-3 font-body text-[color:var(--ss-cream)]">
            <li className="flex items-center gap-3"><Mail size={16} style={{ color: "var(--ss-rust)" }} />
              <a href="mailto:Admin@simplysocialchicago.com" className="hover:text-[color:var(--ss-rust)]">Admin@simplysocialchicago.com</a>
            </li>
            <li className="flex items-center gap-3"><Phone size={16} style={{ color: "var(--ss-rust)" }} />
              <a href="tel:+17792797647" className="hover:text-[color:var(--ss-rust)]">(779) 279-7647</a>
            </li>
            <li className="flex items-center gap-3"><Instagram size={16} style={{ color: "var(--ss-rust)" }} />
              <a href="https://instagram.com/simplysocialchicago" target="_blank" rel="noreferrer" className="hover:text-[color:var(--ss-rust)]">@simplysocialchicago</a>
            </li>
          </ul>
          <div className="font-label text-xs mt-8" style={{ color: "var(--ss-cream-dim)" }}>Service Area</div>
          <p className="mt-2 font-body">Chicago • St. Louis • Surrounding Areas</p>
        </div>
      </div>
      <div className="rule" />
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs" style={{ color: "var(--ss-muted)" }}>
        <span>© {new Date().getFullYear()} Simply Social. All rights reserved.</span>
        <span className="flex items-center gap-4">
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[color:var(--ss-rust)] transition-colors">Admin Login</Link>
          <span>Chicago • St. Louis</span>
        </span>
      </div>
    </footer>
  );
}
